import React, { createContext } from 'react';

const CurrencyContext = createContext()

export default CurrencyContext;
